import { Botao, Cores, Modal } from "@componentes-mu/componentes-mu"

import styles from "./styles.module.scss";
import { FlexColumn, FlexRow } from "../../../components/Flex";
import { InputFile } from "../../../components/InputFile";
import { readAsBase64 } from "../../../utils/utils";

export type AttachItem = {
    base64: string;
    name: string;
};

export type ModalAttachProps = {
    isOpen: boolean;
    files: File[];
    onFilesChange: (files: File[]) => void;
    onRemoveFile: (index: number) => void;
    onClearAll?: () => void;
    onAttachFiles: (items: AttachItem[]) => void;
    onClose: () => void;
}


export const ModalAttach = ({ isOpen, files, onAttachFiles, onRemoveFile, onClearAll, onClose, onFilesChange }: ModalAttachProps) => {

    const hasFiles = files.length > 0;

    const handleConfirm = async () => {
        const converted = await Promise.all(
            files.map(async (f) => ({ base64: await readAsBase64(f), name: f.name }))
        );

        onAttachFiles(converted);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "none",
                boxShadow: "none",
            }}
        >
            <div className={styles.modalContent}>
                <FlexColumn gap="20px" justifyContent="center" alignItems="center">

                    <p className={styles.title}>
                        Deseja anexar um arquivo a este ticket?
                    </p>

                    <div className={styles.fileRow}>
                        <InputFile
                            files={files}
                            multiple
                            label="Selecionar arquivos"
                            onFilesChange={onFilesChange}
                            onRemoveFile={onRemoveFile}
                            onClearAll={onClearAll}
                        />
                    </div>

                    <FlexRow gap="12px" justifyContent="center" className={styles.actions}>
                        <Botao onClick={onClose} cor={Cores.CoresIdentidadeMU.azulMu}>
                            Cancelar
                        </Botao>

                        <Botao
                            onClick={handleConfirm}
                            cor={!hasFiles ? Cores.GradacaoNeutros.CinzaFillMU200 : Cores.CoresIdentidadeMU.azulMu}
                            desabilitado={!hasFiles}
                        >
                            Confirmar
                        </Botao>
                    </FlexRow>
                </FlexColumn>
            </div>
        </Modal>
    )
}